/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "關於";
var Access = "存取";
var Account = "帳戶";
var Actions = "動作";
var Active = "作用中";
var Add = "新增";
var Address = "地址";
var Advanced = "進階";
var Aliases = "別名";
var all = "全部";
var All = "全部";
var Apply = "套用";
var April = "4 月";
var Arbitrary = "任意";
var Assign = "指派";
var August = "8 月";
var Back = "上一步";
var Basic = "基本";
var BNPP_EU = "BNPP_EU";
var Cancel = "取消";
var Category = "種類";
var Classic = "經典";
var Clear = "安全";
var CLI = "CLI";
var Close = "關閉";
var Clusters = "叢集";
var code = "程式碼";
var Complete = "完成";
var Completed = "已完成";
var Compliance = "合規性";
var Compliant = "合規";
var Configuration = "配置";
var Configure = "配置";
var Confirm = "確認";
var Connect = "連接";
var Connected = "已連接";
var Connecting = "連接中";
var Containers = "容器";
var Country = "國家/地區";
var Create = "建立";
var Created = "已建立";
var Creating = "建立";
var Critical = "嚴重";
var Current = "現行";
var Custom = "自訂";
var Dallas = "達拉斯";
var Datacenter = "資料中心";
var Datacenters = "資料中心";
var December = "12 月";
var Delete = "刪除";
var Deleting = "正在刪除";
var Deploying = "正在部署";
var Disabled = "已停用";
var Disconnect = "中斷連線";
var Docs = "文件";
var Documentation = "文件";
var Done = "完成";
var Download = "下載";
var Draft = "草稿";
var Edit = "編輯";
var Enabled = "已啟用";
var Encryption = "加密";
var End = "結束";
var Enterprise = "企業";
var Establish = "建立";
var Expired = "過期";
var Failed = "Failed";
var February = "2 月";
var Filter = "過濾器";
var Filters = "過濾器";
var Finalizing = "終結中";
var Frankfurt = "法蘭克福";
var Free = "免費";
var Friday = "星期五";
var Geography = "地理";
var Help = "說明";
var hour = "小時";
var Hour = "小時";
var hr = "小時";
var IAM = "IAM";
var ID = "ID";
var Images = "映像檔";
var Inactive = "非作用中";
var Incomplete = "未完成";
var Information = "資訊";
var Infrastructure = "基礎架構";
var Instance = "實例";
var Instances = "實例";
var Integrations = "整合";
var Invalid = "無效";
var January = "1 月";
var July = "7 月";
var June = "6 月";
var Key = "索引鍵";
var Launch = "啟動";
var Lite = "Lite";
var Loading = "正在載入";
var Location = "位置";
var Locations = "位置";
var Logging = "記載";
var London = "倫敦";
var March = "3 月";
var May = "5 月";
var Metro = "Metro";
var Minute = "分鐘";
var mo = "月";
var Monday = "星期一";
var Monitoring = "監視";
var Month = "月";
var more = "更多";
var Name = "名稱";
var Namespace = "名稱空間";
var Namespaces = "名稱空間";
var Next = "下一步";
var No = "否";
var None = "無";
var Normal = "一般";
var Note = "附註";
var Notification = "通知";
var November = "11 月";
var Objects = "物件";
var October = "10 月";
var Off = "關閉";
var OK = "OK";
var On = "開啟";
var Open = "開放";
var Osaka = "大阪";
var Overview = "概觀";
var Packages = "套件";
var Pattern = "型樣";
var Pending = "擱置";
var Plan = "方案";
var Premium = "高階";
var Previous = "上一步";
var Product = "Product";
var Products = "產品";
var Project = "專案";
var Projects = "專案";
var Property = "內容";
var provided = "已提供";
var Provider = "提供者";
var Provisioning = "佈建";
var Ready = "備妥";
var Refresh = "重新整理";
var region = "區域";
var Region = "地區";
var Remove = "移除";
var Renew = "更新 (Renew)";
var Repositories = "儲存庫";
var Requested = "已要求";
var Required = "必要";
var Reservations = "保留項目";
var Reset = "重設";
var resources = "資源";
var Resources = "資源";
var Results = "結果";
var Review = "檢閱";
var Routing = "遞送";
var Satellite = "Satellite";
var Saturday = "星期六";
var Save = "儲存";
var Scanning = "掃描中";
var Schedule = "排程";
var Search = "搜尋";
var Secret = "密碼";
var Select = "選取";
var Sending = "傳送中";
var September = "9 月";
var Serverless = "無伺服器";
var Service = "服務";
var Settings = "設定";
var Size = "大小";
var Sort = "排序";
var Source = "來源";
var Start = "啟動";
var State = "狀態";
var Status = "狀態";
var Storage = "儲存空間";
var Submit = "提交";
var Subscription = "訂閱";
var Success = "成功";
var Summary = "摘要";
var Sunday = "星期日";
var Sydney = "雪梨";
var tag = "標籤";
var tags = "標籤";
var Tags = "標籤";
var Thursday = "星期四";
var Tokyo = "東京";
var Topics = "主題";
var Toronto = "多倫多";
var Total = "總計";
var Trash = "垃圾筒";
var Trial = "試用";
var Tuesday = "星期二";
var Unknown = "Unknown";
var Unsupported = "不受支援";
var Update = "更新";
var Upgrade = "升級";
var Value = "值";
var Values = "值";
var Version = "版本";
var View = "檢視";
var Warning = "警告";
var Wednesday = "星期三";
var Workloads = "工作負載";
var Yes = "True";
var Zone = "區域";
var Zones = "區域";
var zhTw = {
	"'{{namespace}}' already exists. Enter another name.": "'{{namespace}}' 已存在。 請輸入另一個名稱。",
	"'Day of week' matches in addition to 'Day of month'": "除了「星期幾」之外，還有「日期」相符項",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "除了「星期幾」之外，還有「日期」相符項。 每天都會觸發表示式。",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "已選取 {{count}} 個項目",
	"{{count}} resources": "{{count}} 個資源",
	"{{count}} resources included": "包含 {{count}} 個資源",
	"{{current}} of {{total}} pages": "{{current}} / {{total}} 頁",
	"{{datahookName}} response": "{{datahookName}} 回應",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "{{label}} 型樣",
	"{{min}}–{{max}} items": "{{min}}–{{max}} 項",
	"{{min}}–{{max}} of {{total}} items": "{{min}}–{{max}} / {{total}} 項",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} 模組，{{resourcesCount}} 資源",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} 需要以下選項才能部署。",
	"{{price}} per {{unit}}": "{{price}}，每個 {{unit}}",
	"{{price}} per month": "每個月 {{price}}",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/月",
	"{{resourcesCount}} resources": "{{resourcesCount}} 個資源",
	"{{rolesCount}} Role": "{{rolesCount}} 個角色",
	"{{rolesCount}} Roles": "{{rolesCount}} 個角色",
	"{{topicsCount}} topic active for this instance.": "此實例有 {{topicsCount}} 個主題處於作用中狀態。",
	"{{topicsCount}} topics active for this instance.": "此實例有 {{topicsCount}} 個主題處於作用中狀態。",
	"{{value}} percent status progress": "{{value}} 百分比狀態進度",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}}（請建立新的叢集，以嘗試此測試版）",
	"{{version}} (update to an earlier version first)": "{{version}}（請先更新為較早的版本）",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>您必須有 Cloud Object Storage 實例才能建立衛星位置。</span> <a>進一步瞭解。</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / 實例",
	"1 item selected": "已選取 1 個項目",
	"1 of 1 page": "1 / 1 頁",
	"1 role": "1 個角色",
	"1–1 of 1 item": "1–1 / 1 項",
	"A collection of keys that belong to your service instance.": "屬於您的服務實例的金鑰集合。",
	"A key can only have 5 aliases.": "一個金鑰只能有 5 個別名。",
	"A Key Protect key": "Key Protect 金鑰",
	"A location name is required. ": "位置名稱是必要項目。 ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "多租戶金鑰管理服務。 建立和管理加密密鑰，以加密應用程式中的資料並控制對資料的存取權。",
	"A name is required.": "名稱是必要項目。",
	"A rotation policy of 12 months is recommended": "建議採取 12 個月的輪換原則",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "{{sourceServiceDisplayName}} 和 {{serviceDisplayName}} 之間需要服務對服務授權才能關聯加密金鑰。 Key Protect 將在您同意的情況下建立一個。 或者您可以手動建立一個。",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "單租戶金鑰管理服務。 使用專用客戶控制的「硬體安全模組」所提供的金鑰加密配置檔，建立和管理加密密鑰。 ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "標籤只能包含英數字元、空格、底線、橫線、句點和一個冒號。",
	"A tag cannot end with a colon.": "標籤不能以冒號結尾。",
	"A tag cannot include more than 128 characters.": "標籤不能包含超過 128 個字元。",
	"A tag cannot start with a colon.": "標籤不能以冒號開頭。",
	"A tag should not have spaces around a colon.": "標籤在冒號周圍不應有空格。",
	About: About,
	Access: Access,
	"Access management tags": "存取管理標籤",
	"Access management tags (optional)": "存取管理標籤（選用）",
	"Access management tags help you apply flexible access policies on specific resources.": "存取管理標籤可協助您對特定資源套用彈性的存取原則。",
	Account: Account,
	"Account type": "帳戶類型",
	"Action required": "所需的動作",
	Actions: Actions,
	Active: Active,
	"Active promotions": "作用中的促銷",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "此資源已啟用活動追蹤器事件收集，並將其傳送至遞送配置定義的目標。",
	"Activity tracker events": "Activity tracker 事件",
	"Activity tracking": "活動追蹤",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "請將單一名稱空間或多個名稱空間新增至特定的名稱空間清單。",
	"Add a single project or multiple projects to your specific project's list.": "請將單一專案或多個專案新增至特定的專案清單。",
	"Add Activity tracker event collection": "新增活動追蹤器事件集合",
	"Add activity tracking": "新增活動追踪",
	"Add event collection": "新增事件集合",
	"Add hosts": "新增主機",
	"Add hosts to meet the minimum service requirements.": "新增主機以符合最低服務需求。",
	"Add key alias (optional)": "新增金鑰別名（選用）",
	"Add key description (optional)": "新增金鑰說明（選用）",
	"Add logging": "新增記載",
	"Add monitoring": "新增監視",
	"Add namespace": "新增名稱空間",
	"Add New": "新增",
	"Add project": "新增專案",
	"Add storage": "新增儲存體",
	"Add tags": "新增標籤",
	"Add to estimate": "新增至預估值",
	"Add to existing": "新增至現有",
	"Add to project": "新增至專案",
	"Adding ...": "正在新增...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "解決下列任何必要動作，以順利佈建您的服務。 您可以立即或在建立服務之後完成這些步驟。",
	"Address field": "地址欄位",
	Advanced: Advanced,
	"Advanced options": "進階選項",
	"After connection": "連線之後",
	"After the service cluster is created, assign storage to the cluster.": "建立服務叢集之後，將儲存體指派給叢集。",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "中斷 Event Notifications 連線後，{{serviceName}} 實例將從 Event Notifications 實例的來源服務清單中移除。",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "別名只能包含英數字元和 -_。",
	"Aliases must be at least 2 characters and at most 90 characters.": "別名必須至少為 2 個字元，且最多 90 個字元。",
	all: all,
	All: All,
	"All audit events (default target)": "所有審核事件（預設目標）",
	"All audit events from your account will be sent to a new instance": "您帳戶中的所有審核事件都將傳送到新實例",
	"All audit events from your account will be sent to an existing instance": "您帳戶中的所有審核事件都將傳送到現有實例",
	"All namespaces": "所有名稱空間",
	"All namespaces not supported": "不支援所有名稱空間",
	"All platform logs": "所有平台日誌",
	"All prerequisite services are installed on the location.": "所有必備服務都安裝在位置上。",
	"All projects": "所有專案",
	"All projects not supported": "不支援所有專案",
	"All regions": "所有區域",
	"All resource groups": "所有資源群組",
	"All secret groups": "所有密鑰群組",
	"All types": "所有類型",
	"All zone names must be unique": "所有區域名稱都必須是唯一的",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "{{roleName}} 角色 ({{actionCount}}) 容許的動作",
	"Already have an account? <a>Log in</a>": "已經有帳戶了嗎？ <a>登入</a>",
	"An error occurred when fetching secrets. Try again later.": "提取密碼時發生錯誤。 請稍後重試。",
	"An instance of Event Notifications <a>Create new instance</a>": "Event Notifications <a>建立新實例</a>的實例",
	"An unexpected error occurred.": "發生非預期的錯誤。",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "分析和管理日誌以快速解決問題並主動預防停機。 <a>進一步瞭解</a>",
	Apply: Apply,
	"Apply a code": "套用代碼",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "您確定要中斷 {{serviceName}} 實例與 \"{{ENInstanceName}}\" 實例的連線嗎？",
	"Are you sure you want to close the side panel?": "您確定要關閉側邊畫面嗎？",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "您確定要關閉此畫面嗎？ 您所做的任何選擇都將遺漏。",
	"Are you sure?": "您確定嗎？",
	Assign: Assign,
	"Associate key": "關聯金鑰",
	"Attachment name": "連接名稱",
	"Audit event collection is already enabled for this resource": "已為此資源啟用審核事件收集",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "建議收集審核事件，以最佳化故障排除並減少停機時間",
	"Audit events (error)": "審核事件（錯誤）",
	"Audit events from {{region}} will be sent to a new instance": "{{region}} 的審核事件將會傳送至新實例",
	"Audit events from {{region}} will be sent to an existing instance": "{{region}} 的審核事件將會傳送至現有實例",
	"Audit events in {{region}}": "{{region}} 中的審核事件",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "將根據定義的遞送範圍從啟用的 IBM Cloud 服務收集審核事件。",
	"Audit events...": "審核事件…",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "鑑別是必要流程，否則您沒有適當的許可權，無法執行此動作。",
	"Authorization error": "授權錯誤",
	"Authorization met": "符合授權",
	"Authorization needed": "需要授權",
	"Authorize now": "立即授權",
	"Authorizing...": "正在授權…",
	Back: Back,
	"Base URI": "基本 URI",
	"Base64 encoded key material": "Base64 已編碼的金鑰資料",
	Basic: Basic,
	"Before you begin": "開始之前",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "在專案可以驗證或部署配置之前，專案服務需要在此帳戶中獲得授權，才能與 Schematics、型錄管理、Secrets Manager 及資源控制器進行通訊。 具有這些服務所需存取權的使用者可以透過在此帳戶中建立專案來自動授與授權，或者他們可以手動建立服務至服務授權的服務。 此授權僅需要一次。",
	"Billing information": "計費資訊",
	"Billing period": "計費期間",
	BNPP_EU: BNPP_EU,
	"Bucket name": "儲存區名稱",
	"By {{name}}": "依 {{name}}",
	"By clicking Save, you are creating the following access:": "按一下「儲存」，即會建立下列存取權：",
	"Can't retrieve details": "無法擷取詳細資料",
	Cancel: Cancel,
	"Cannot list integrations!": "無法列出整合！",
	"Cannot view keys in this instance": "無法檢視此實例中的金鑰",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "需收費。 <a>進一步瞭解</a>",
	"Choose a cluster version": "選擇叢集版本",
	"Choose a key ring": "選擇金鑰環",
	"Choose a resource group": "選擇資源群組",
	"Choose account...": "選擇帳戶…",
	"Choose an existing HPCS instance.": "選擇現有的 HPCS 實例。",
	"Choose an existing Key Protect instance.": "選擇現有的 Key Protect 實例。",
	"Choose an instance": "選擇實例",
	"Choose an option": "選擇選項",
	"Choose category...": "選擇種類…",
	"Choose location": "選取位置",
	"Choose plan": "選擇計劃",
	"Choose property...": "選擇內容…",
	"Choose provider...": "選擇提供者…",
	"Choose secret...": "選擇密鑰…",
	"Choose service instance...": "選擇服務實例…",
	"Choose source name...": "選擇來源名稱…",
	"Choose source...": "選擇來源…",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "選擇哪個 IBM Cloud Monitoring 實例將接收來自 IBM Cloud 上已啟用之服務實例的平台度量值。",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "選擇哪個 IBM Log Analysis 實例將接收來自 IBM Cloud 上已啟用之服務實例的平台日誌。",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "全部清除",
	"Clear all selected items": "清除所有選取項目",
	"Clear filters": "清除過濾器",
	"Clear selected": "清除選取的項目",
	"Clear selected item": "清除選取項目",
	"Clear selection": "清除選取項目",
	CLI: CLI,
	Close: Close,
	"Close menu": "關閉功能表",
	"Close page navigation menu": "關閉頁面導覽功能表",
	"Close Panel": "關閉畫面",
	"Close Push Panel": "關閉推送畫面",
	"Closing side panel": "正在關閉側邊畫面",
	"Cloud Logs": "雲端日誌",
	"Cloud Logs instance": "雲端日誌實例",
	"Cloud Logs instance name": "雲端日誌實例名稱",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Cloud Object Storage 實例",
	"Cluster \"{{name}}\" is being deleted.": "正在刪除叢集 \"{{name}}\"。",
	"Cluster management": "叢集管理",
	"Cluster version": "叢集版本",
	"Cluster version cannot be updated.": "無法更新叢集版本。",
	Clusters: Clusters,
	code: code,
	"Code sample": "程式碼範例",
	"Collapse all rows": "收合所有列",
	"Collapse group": "收合群組",
	"Collapse row": "收合列",
	"Collapse summary": "收合摘要",
	"Compact (24px)": "精簡 (24px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "配置詳細資料",
	"Configuration name": "配置名稱",
	Configure: Configure,
	"Configure activity tracking": "配置活動追踪",
	"Configure encryption": "配置加密",
	"Configure logging": "配置記載",
	"Configure monitoring": "配置監視",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "連接至事件通知",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "將您的 {{serviceName}} 實例連接到現有的 Event Notifications 實例。",
	Connected: Connected,
	"Connected instance": "已連接實例",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "連接的事件通知實例不存在。 請與管理員聯絡。",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "請聯絡您的帳戶管理者來存取佈建 Key Protect 的計劃。",
	"Contact your account administrator to access a resource group to provision Key Protect.": "請聯絡您的帳戶管理者，以存取資源群組來佈建 Key Protect。",
	"Contact your administrator for access.": "若要存取，請聯絡管理者。",
	"Contact your administrator for additional assistance.": "如需其他協助，請與管理者聯絡。",
	"Container registry": "Container Registry",
	Containers: Containers,
	"Copied to clipboard": "已複製到剪貼簿",
	"Copy to clipboard": "複製到剪貼簿",
	"Cost details": "成本詳細資料",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "無法載入計價資訊。 請重新整理頁面，或稍後重試。",
	Country: Country,
	Create: Create,
	"Create a key": "建立金鑰",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "建立日誌遞送目標以支援日誌管理和分析，從而快速解決問題並主動預防停機。 <a>進一步瞭解</a>",
	"Create a new instance to get started.": "建立一個新實例以開始。",
	"Create a project": "建立專案",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "建立 Satellite 位置以將 IBM Cloud 帶到任何位置。 如需相關資訊，<a>請參閱文件</a>。",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "建立活動追蹤器事件遞送目標和遞送，以支援監視和審核 IBM Cloud 活動，增強安全性和合規性。 <a>進一步瞭解</a>",
	"Create an encryption key or import your own key.": "建立加密金鑰或匯入您自己的金鑰。",
	"Create cluster": "建立叢集",
	"Create failed": "建立失敗",
	"Create instance": "建立實例",
	"Create location": "建立位置",
	"Create new": "建立新的",
	"Create new instance": "建立新的實例",
	"Create new key": "建立新的金鑰",
	"Create new secret": "建立新的密碼",
	"Create reference": "建立參照",
	"Create resource": "建立資源",
	"Create Satellite location": "建立 Satellite 位置",
	"Create secret": "建立密碼",
	"Create services": "建立服務",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "在 Event Notifications 中建立主題、目的地和訂閱，以便收到由您的 {{serviceName}} 產生的事件通知",
	Created: Created,
	Creating: Creating,
	"Creating ...": "正在建立...",
	"Creating...": "正在建立...",
	Critical: Critical,
	"CRON expression": "CRON 表示式",
	Current: Current,
	Custom: Custom,
	"Custom access": "自訂存取權",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Datahook 引數區塊",
	"Datahook Params": "Datahook 參數",
	"Datahook response": "Datahook 回應",
	"Day of month": "日期",
	"Day of Month (UTC)": "日期 (UTC)",
	"Day of week": "星期幾",
	"Day of week (UTC)": "星期幾 (UTC)",
	December: December,
	"Dedicated hosts": "專用主機",
	"Default target": "預設目標",
	"Default title": "預設標題",
	"Define project details": "定義專案詳細資料",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "定義此事件所產生事件的循環計時。 選取預先定義的型樣，並根據您的需要加以自訂。 排程以「世界標準時間 (UTC)」指定。",
	"Define the scope of audit events collected": "定義收集的審核事件的範圍",
	Delete: Delete,
	"Delete cluster": "刪除叢集",
	"Delete failed": "刪除失敗",
	"Delete retry wait": "刪除重試等待",
	"Delete the persistent storage used by this cluster": "刪除此叢集使用的持續性儲存空間",
	Deleting: Deleting,
	"Deleting...": "正在刪除...",
	"Deploy failed": "部署失敗",
	"Deploy retry wait": "部署重試等待",
	Deploying: Deploying,
	"Deployment ready": "部署備妥",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "已淘汰版本，支援將於 {{when}} 時結束。 請更新版本以繼續獲得支援。",
	"Description (optional)": "說明（選用）",
	"Description of the source": "來源的說明",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "中斷 Event Notifications 連線",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "DNS 子網域標籤不得超過 {{maxLength}} 個字元。",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "完成編輯",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "在更新期間，您的叢集主節點、工作者節點、應用程式及資源都會繼續執行。 更新完成之後，您可以更新工作者節點版本。 如需指示及版本間差異的相關資訊，<a>請檢閱文件</a>。",
	Edit: Edit,
	"Edit activity tracker integration": "編輯活動追蹤器整合",
	"Edit Array": "編輯陣列",
	"Edit columns": "編輯直欄",
	"Edit configuration": "編輯配置",
	"Edit details": "編輯詳細資料",
	"Edit JSON": "編輯 JSON",
	"Edit logging integration": "編輯記載整合",
	"Edit secure value": "編輯安全值",
	"Edit tags": "編輯標籤",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "透過連線 Event Notifications 服務實例，為您的 {{serviceName}} 實例啟用生命週期通知。",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "啟用監督、合規性，以及審核管理 IBM Cloud 帳戶的作業和風險。",
	Encryption: Encryption,
	"Encryption key associated": "相關聯的加密金鑰",
	"Encryption options menu": "加密選項功能表",
	End: End,
	"End date": "結束日期",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "使用整合來加強 Schematics 體驗。 現在就開始新增整合，從下面的其中一個選項選取。",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "輸入可部署架構的配置名稱。  例如：production-vpc",
	"Enter a password": "輸入密碼",
	"Enter a valid CRN": "輸入有效的 CRN",
	"Enter array values. Quotations are added to values after you save.": "輸入陣列值。 儲存之後，會將報價新增至值。",
	"Enter name and description": "輸入名稱和說明",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "輸入主機區域的名稱。 為了實現高可用性，請根據基礎架構提供者區域在這三個區域中配置您的主機。 <a>為何需要區域？</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "請輸入以逗點區隔的名稱空間。 按一下「新增」之後，即會將新的名稱空間併入在清單中，並自動加以選取。",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "請輸入以逗點區隔的專案。 按一下「新增」之後，即會將新的專案併入在清單中，並自動加以選取。",
	"Enter source name": "輸入來源名稱",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "請輸入 Cloud Object Storage 實例中現有儲存區的確切名稱。 如果未提供，則會為您建立新的儲存區。",
	Enterprise: Enterprise,
	"Entire secret": "整個密鑰",
	"Environment (optional)": "環境（選用）",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "環境可以包含跨相關配置共用的內容。 在配置中，您可以置換環境所提供的任何值。 <a>進一步瞭解</a>",
	"Error": "錯誤",
	"Error checking existing services status": "檢查現有服務狀態時發生錯誤",
	"Error checking host status": "檢查主機狀態時發生錯誤",
	"Error checking storage status": "檢查儲存體狀態時發生錯誤",
	"Error fetching tags": "提取標籤時發生錯誤",
	"Error icon": "錯誤圖示",
	"Error loading accounts": "載入帳戶時發生錯誤",
	"Error loading categories": "載入種類時發生錯誤",
	"Error loading groups": "載入群組時發生錯誤",
	"Error loading instances": "載入實例時發生錯誤",
	"Error loading keys": "載入金鑰時發生錯誤",
	"Error loading pricing": "載入計價時發生錯誤",
	"Error loading properties": "載入內容時發生錯誤",
	"Error loading providers": "載入提供者時發生錯誤",
	"Error loading regions": "載入區域時發生錯誤",
	"Error loading resource groups": "載入資源群組時發生錯誤",
	"Error loading S2S auth": "載入 S2S 鑑別時發生錯誤",
	"Error loading secrets": "載入密鑰時發生錯誤",
	"Error loading source names": "載入來源名稱時發生錯誤",
	"Error loading sources": "載入來源時發生錯誤",
	"Error loading types": "載入類型時發生錯誤",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "驗證此代碼時發生錯誤。 請確定促銷代碼中沒有包含任何引號。",
	Establish: Establish,
	"Estimate costs": "預估成本",
	"Estimated cost per instance": "每個實例的預估成本",
	"Estimated starting cost": "預估起始成本",
	"Estimated total ({{count}} instances)": "預估總計（{{count}} 個實例）",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Event Notifications 實例",
	"Event Notifications service instance": "Event Notifications 服務實例",
	"Event Source Manager": "事件來源管理程式",
	"Every 2 hours": "每隔 2 小時",
	"Every 2 minutes": "每 2 分鐘",
	"Every 3 hours": "每 3 小時",
	"Every 4 hours": "每隔 4 小時",
	"Every 5 minutes": "每 5 分鐘",
	"Every 6 hours": "每 6 小時",
	"Every 10 minutes": "每 10 分鐘",
	"Every 15 minutes": "每隔 15 分鐘",
	"Every day": "每日",
	"Every fifth day": "每五天",
	"Every fourth day": "每四天",
	"Every fourth month": "每 4 個月",
	"Every hour": "每小時",
	"Every minute": "每分鐘",
	"Every month": "每月",
	"Every second day": "每隔一天",
	"Every second month": "每 2 個月",
	"Every sixth month": "每 6 個月",
	"Every third day": "每三天",
	"Every third month": "每 3 個月",
	"Examples: access:dev, proj:version-1": "範例：access:dev、proj:version-1",
	"Examples: env:dev, version-1": "範例：env:dev、version-1",
	"Existing instance": "現有實例",
	"Exiting encryption selection": "退出加密選擇",
	"Expand all rows": "展開所有列",
	"Expand group": "展開群組",
	"Expand row": "展開列",
	"Expand summary": "展開摘要",
	Expired: Expired,
	"Expired (beta)": "過期（測試版）",
	"Expires {{when}}": "{{when}} 時到期",
	"Expires after beta": "在測試版之後到期",
	"Extra large (64px)": "超大型 (64px)",
	"Extra small (24px)": "特小型 (24px)",
	Failed: Failed,
	"Failed to check permission": "無法檢查許可權",
	"Failed to create configuration": "無法建立配置",
	"Failed to create key": "無法建立金鑰",
	"Failed to create policy": "無法建立原則",
	"Failed to create project": "無法建立專案",
	"Failed to fetch": "無法提取",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "無法提取 IBM Cloud Activity Tracker 實例。",
	"Failed to fetch IBM Cloud Monitoring instances.": "無法提取 IBM Cloud Monitoring 實例。",
	"Failed to fetch IBM Log Analysis instances.": "無法提取 IBM Log Analysis 實例。",
	"failure state": "失敗狀態",
	February: February,
	"Fetch data": "提取資料",
	Filter: Filter,
	"Filter instance by region": "依地區過濾實例",
	"Filter...": "過濾...",
	Filters: Filters,
	"Filters:": "過濾器：",
	Finalizing: Finalizing,
	"Finalizing cluster...": "正在終結叢集...",
	"Finalizing workers...": "正在終結工作者節點...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "搭配使用 IBM Cloud Activity Tracker，可讓您看到 Cloud 資源的作業層面。",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "搭配使用 IBM Cloud Monitoring，可讓您看到 Cloud 資源的作業層面。",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "搭配使用 IBM Log Analysis，可讓您看到 Cloud 資源的作業層面。",
	"Get started": "開始使用",
	"Get started with Security and Compliance Center": "開始使用 Security and Compliance Center",
	"Give your key an alias for easy retrieval later.": "為您的金鑰指定一個別名，以便日後輕鬆擷取。",
	"Helm catalog": "Helm 型錄",
	Help: Help,
	"Hide password": "隱藏密碼",
	"Host usage\n(used / total)": "主機用量（已使用/總計）",
	"Hosts needed": "所需主機",
	"Hosts requirements met": "符合主機需求",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "小時 (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "我同意使用我的記號代表我在來源服務 {{sourceServiceDisplayName}} 和目標服務 {{serviceDisplayName}} 之間建立服務對服務原則。",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "我確認我想要從 {{instance}} 停止接收平台日誌",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "我確認我想要從 {{instance}} 停止接收平台度量值",
	"IaaS ready": "IaaS 就緒",
	IAM: IAM,
	"IAM credentials": "IAM 認證",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID：{{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "如果未指派金鑰環，則金鑰將新增至預設金鑰環。",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "如果選取的話，陣列將儲存為 \"__NOT_SET__\" 字串。",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "如果起始值不是有效的字串陣列，則下方會出現空的或單一項目陣列。",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "如果您的使用者標籤與計費相關，請考慮將標籤寫成 key:value 配對，例如",
	Images: Images,
	"Import your own key": "匯入您自己的金鑰",
	"In progress": "進行中",
	"in progress state": "進行中狀態",
	Inactive: Inactive,
	"inactive state": "非作用狀態",
	Incomplete: Incomplete,
	"incomplete state": "不完整狀態",
	Information: Information,
	"information state": "資訊狀態",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "基礎架構區域",
	Instance: Instance,
	"Instance ID": "實例 ID",
	"Instance location": "實例位置",
	"Instance name": "實例名稱",
	"Instance(s) in {{region}}": "{{region}} 中的實例",
	"Instance(s) in region": "地區中的實例",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "伺服器內部錯誤。 請稍候，然後重試您的動作。 如果問題持續存在，請開立支援問題單。",
	"Interpolated URI": "內插 URI",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "無效的 Datahook 物件，使用最後一個有效選項",
	"Invalid label name.": "標籤名稱無效。",
	"Invalid label prefix or name.": "標籤字首或名稱無效。",
	"Invalid label value.": "標籤值無效。",
	"Items per page:": "每頁項目數：",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "金鑰別名",
	"Key CRN": "金鑰 CRN",
	"Key description": "金鑰說明",
	"Key description must be at least 2 characters and no more than 240 characters.": "金鑰說明必須至少 2 個字元，且不超過 240 個字元。",
	"Key ID": "金鑰 ID",
	"Key management": "金鑰管理",
	"Key management service": "金鑰管理服務",
	"Key material": "金鑰資料",
	"Key material is required to import a key": "匯入金鑰需要金鑰資料",
	"Key material length must be 128, 192, or 256 bits": "金鑰資料長度必須為 128、192 或 256 位元",
	"Key material must be base64": "金鑰資料必須是 base64",
	"Key name": "金鑰名稱",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Key Protect 實例名稱",
	"Key ring": "金鑰環",
	"Key value": "鍵值",
	"Label must be of the form 'key:value'.": "標籤必須是 'key:value' 格式。",
	"Label name must be no more than {{maxLength}} characters.": "標籤名稱不得超過 {{maxLength}} 個字元。",
	"Label prefix must be a valid DNS subdomain.": "標籤字首必須是有效的 DNS 子網域。",
	"Label prefix must be no more than {{maxLength}} characters.": "標籤字首不得超過 {{maxLength}} 個字元。",
	"Label value must be no more than {{maxLength}} characters.": "標籤值不得超過 {{maxLength}} 個字元。",
	"Large (48px)": "大型 (48px)",
	"Last modified": "前次修改時間",
	"Last scanned": "前次掃描",
	"Last updated": "前次更新",
	Launch: Launch,
	"Launch activiting tracking": "啟動作用中追蹤",
	"Launch in new window": "在新視窗中啟動",
	"Launch logging": "啟動記載",
	"Launch monitoring": "啟動監視",
	"Learn more": "進一步瞭解",
	"learn more.": "進一步瞭解。",
	"Learn more.": "進一步瞭解。",
	"List of actions": "動作清單",
	"list of code sample types": "程式碼範例類型的清單",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "正在載入指示器",
	"Loading...": "正在載入...",
	"Locate by CRN within your account": "在您的帳戶中透過 CRN 尋找",
	Location: Location,
	"Location summary": "位置摘要",
	"Location:": "位置：",
	Locations: Locations,
	"Log collection is already enabled for this resource": "已為此資源啟用日誌收集",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "此資源已啟用日誌收集，並將其傳送至遞送配置定義的目標。",
	Logging: Logging,
	"Logging (error)": "記載（錯誤）",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "建議記載以最佳化故障排除並減少停機時間",
	"Logging...": "正在記載…",
	London: London,
	"Looking for valid service to service authorization policy...": "正在尋找有效的服務對服務授權原則…",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "您似乎遺漏建立原則所需的權限。 聯絡您的帳戶管理者",
	"Looks like you don't have access to view account information.": "您似乎沒有存取權，無法檢視帳戶資訊。",
	"Looks like you don't have access to view the billing period": "您似乎沒有存取權，無法檢視計費期間",
	"Looks like you don't have any scans": "您似乎沒有任何掃描",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "您似乎沒有檢視此資訊所需的存取權。 請聯絡您的帳戶管理者，以驗證您的許可權。",
	"Looks like you don't have the correct access": "您似乎沒有正確的存取權",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "您似乎沒有正確的存取權。 您必須具有目標服務的存取權，才能建立服務之間的授權。",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "確定您已在 Event Notifications 中設定「主題」、「訂閱」及「目的地」。",
	"Manage encryption by enabling a key management service (KMS).": "透過啟用金鑰管理服務 (KMS) 來管理加密。",
	"Manage routing": "管理遞送",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "管理您 IBM Cloud 資源、服務及應用程式所使用之加密金鑰的生命週期。",
	"Managed from": "管理位置",
	March: March,
	May: May,
	"Media gallery video": "媒體展示區影片",
	"Medium (40px)": "中型 (40px)",
	"Metadata location": "meta 資料位置",
	Metro: Metro,
	"Minimum host requirements are met.": "符合主機需求下限。",
	Minute: Minute,
	"Minute (UTC)": "分鐘 (UTC)",
	"Missing prerequisite services": "遺漏必備服務",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "在這裡修改傳遞至您的 Datahook 的引數。",
	"Mon-Fri": "星期一到星期五",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "透過設定掃描來監視所有環境的合規性。",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "監視和審核 IBM Cloud 活動，以增強安全性和合規性。 <a>進一步瞭解</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "月 (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "名稱已在使用中。 提供唯一名稱。",
	"Name must be between 2 and 90 characters": "名稱必須介於 2 到 90 個字元之間",
	"Name this project": "命名此專案",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "新建實例",
	Next: Next,
	"Next page": "下一頁",
	"Next: Customize": "下一步：自訂",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "沒有可用的型錄區域",
	"No Cloud Object Storage instance is available.": "沒有可用的 Cloud Object Storage 實例。",
	"No code preview has been configured for terraform. Please visit our docs to ": "未配置 Terraform 的程式碼預覽。 請造訪我們的文件 ",
	"No configurations available": "沒有可用的配置",
	"No events can be scheduled with your selected CRON expression.": "無法使用您選取的 CRON 表示式來排程任何事件。",
	"No Hyper Protect Crypto Services instances found": "找不到 Hyper Protect Crypto Services 實例",
	"No instances found": "找不到實例",
	"No item matches the filters. Clear the filters and try again.": "沒有項目符合過濾器。 請清除過濾器，然後再試一次。",
	"No items available to display. Select an instance and bucket to view objects.": "沒有可顯示的項目。 選取實例及儲存區以檢視物件。",
	"No items match the current filter.": "沒有項目符合現行過濾器。",
	"No keys available": "沒有可用的金鑰",
	"No matches found. To create new tags, contact your tag administrator.": "找不到任何相符項目。 若要建立新的標籤，請與標籤管理者聯絡。",
	"No matching options": "沒有相符的選項",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "此帳戶沒有相符的區域 ID 可用。 如果您認為這是錯誤，請重新整理頁面或聯絡管理者。",
	"No plans found": "找不到計劃",
	"No regions available": "沒有可用的區域",
	"No resource groups available": "沒有可用的資源群組",
	"No secret available": "沒有可用的密碼",
	"No secret group available": "沒有可用的密碼群組",
	"No service instance available": "沒有可用的服務實例",
	"No valid version update options are available.": "沒有可用的有效版本更新選項。",
	"Non-compliant": "不合規",
	None: None,
	"None available": "缺",
	Normal: Normal,
	"Normal (48px)": "正常 (48px)",
	"Not authorized": "未獲授權",
	"Not ready": "未就緒",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "物件",
	"Object storage": "Object Storage",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "Object Storage 用來儲存您位置的相關資料，以及位置叢集的備份。 <a>進一步瞭解。</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "一天一次",
	"Once a month": "一個月一次",
	"Once a week": "一週一次",
	"Once a year": "一年一次",
	Open: Open,
	"Open dashboard": "開啟儀表板",
	"Open Dashboard": "開啟儀表板",
	"Open menu": "開啟功能表",
	"Open page navigation menu": "開啟頁面導覽功能表",
	"Open reference picker": "開啟參照選取器",
	"Open tab list": "開啟標籤清單",
	Osaka: Osaka,
	"Overflow menu": "溢位功能表",
	"Overflow Menu": "溢位功能表",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "第 {{pageNumber}} 頁",
	"Page Navigation": "頁面導覽",
	"Page navigation menu": "頁面導覽功能表",
	"Page number": "頁碼",
	Pattern: Pattern,
	"Pay-As-You-Go": "隨收隨付制",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "平台存取權",
	"Platform logs from {{region}} will be sent to a new instance": "{{region}} 的平台日誌將會傳送至新實例",
	"Platform logs from {{region}} will be sent to an existing instance": "{{region}} 的平台日誌將會傳送至現有實例",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "{{region}} 的平台日誌將會傳送至目標實例。 <a>進一步瞭解</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "將根據定義的遞送範圍從啟用的 IBM Cloud 服務收集平台日誌。",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "在套用促銷代碼之前，請<a>註冊</a>以便建立，或是進行<a>登入</a>。",
	"Prefix filter": "字首過濾器",
	Premium: Premium,
	"Preparing master, workers...": "正在準備主節點、工作者節點...",
	"Preparing master...": "正在準備主節點...",
	"Prerequisite services installed": "已安裝必備服務",
	Previous: Previous,
	"Previous page": "上一頁",
	"Pricing Plans": "定價方案",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "提供金鑰的更詳細說明。 為了保護您的隱私權，請勿使用個人資料（例如您的名稱或位置）作為說明。 您無法在建立金鑰之後變更此項。",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "以視覺化方式顯示由 IBM Cloud 提供支援的資源應用程式的效能和性能。",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "已可供套用？",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "重新整理 Cloud Object Storage 實例",
	"Refresh data": "重新整理資料",
	"Refresh secrets": "重新整理密碼",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "移除排序",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "不支援呈現修改連結鉤，以防止非預期的資源變更。",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "正在要求建立...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "重設過濾器",
	"Reset to default": "重設為預設值",
	"Reset zoom": "重設縮放",
	"Resource Configuration": "資源配置",
	"Resource group": "資源群組",
	"Resource group:": "資源群組：",
	"Resource list": "資源成本",
	"Resource List": "資源清單",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "未包括在成本中的資源",
	"Restricted access": "受限存取權",
	Results: Results,
	"Retrying delete": "正在重試刪除",
	"Retrying deploy": "正在重試部署",
	"Revert {{resetCount}} to default": "將 {{resetCount}} 回復為預設值",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "檢閱對 {{resourceDisplayName}} 的存取指派",
	"Review settings in Event Notifications": "檢閱 Event Notifications 中的設定",
	"Review the following access group policies to ensure you're assigning the right level of access.": "請檢閱下列存取群組原則，以確保您指派的存取權層次是正確的。",
	"Rotation interval": "輪換間隔",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "輪換原則可決定自動金鑰輪換之間的間隔。 例如，一個月的間隔表示金鑰將每 30 天輪換一次。 如果已啟用此原則，則表示此實例存在實例原則，如果未採取其他動作，則所顯示的輪換間隔將套用至金鑰。 如果已停用，請啟用它以設定此金鑰的原則。",
	"Rotation policy": "輪換原則",
	"Rotation policy disabled": "輪換原則已停用",
	"Route name": "路由名稱",
	Routing: Routing,
	"Routing scope": "遞送範圍",
	"Row height": "列高度",
	"Sample not yet available": "尚未提供範例",
	"Sao Paulo": "聖保羅",
	"Sat-Sun": "星期六到星期日",
	Satellite: Satellite,
	"Satellite container": "Satellite 儲存器",
	"Satellite location": "Satellite 位置",
	"Satellite location base cost": "Satellite 位置基本成本",
	"Satellite location base functionality": "Satellite 位置基礎功能",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "正在儲存...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Schematics 工作區及其他專案資料儲存在選取的區域及資源群組中。 <a>進一步瞭解。</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "在此區域中佈建 Schematics 工作區。 您的專案仍然可以將資源部署至任何地區。",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Schematics 工作區在此資源群組中佈建。 您的專案仍然可以將資源部署至任何資源群組。",
	Search: Search,
	"Search in this instance": "在此實例中搜尋",
	Secret: Secret,
	"Secret configured": "密碼已配置",
	"Secret group": "密碼群組",
	"Secret type": "密鑰類型",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "安全值",
	"See details": "參看詳細資料",
	Select: Select,
	"Select a location to see what steps you need to take next.": "選取位置以查看您接下來需要採取的步驟。",
	"Select a project": "選取專案",
	"Select a reference": "選取參照",
	"Select a region": "選取地區",
	"Select a resource group": "選取資源群組",
	"Select a role to determine the level of access for the source service.": "請選取角色，以決定來源服務的存取層次。",
	"Select a secret": "選取密碼",
	"Select a secret group": "選取密碼群組",
	"Select a service instance": "選取服務實例",
	"Select all {{totalRowCount}} items": "選取全部 {{totalRowCount}} 個項目",
	"Select all rows on page": "選取頁面上的所有列",
	"Select an environment": "選取環境",
	"Select an existing configuration": "選取現有的配置",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "選取 IBM Cloud Monitoring 實例以便接收平台度量值",
	"Select an IBM Log Analysis instance to receive platform logs": "選取 IBM Log Analysis 實例以便接收平台日誌",
	"Select an instance": "選取實例",
	"Select an instance to show keys": "選取實例以顯示金鑰",
	"Select an option...": "選取選項...",
	"Select existing key": "選取現有金鑰",
	"Select from Secrets Manager": "從 Secrets Manager 選取",
	"Select KMS instance": "選取 KMS 實例",
	"Select namespaces": "選取名稱空間",
	"Select one or more namespaces": "選取一個以上的名稱空間",
	"Select one or more projects": "選取一個以上的專案",
	"Select prerequisites": "選取必要條件",
	"Select projects": "選取專案",
	"Select region and resource group": "選取區域和資源群組",
	"Select row": "選取列",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "選取最接近基礎架構所在位置的 <a>IBM Cloud 區域</a>，以確保低網路延遲。",
	"Select the following tile to deploy it.": "選取下列磚以進行部署。",
	"Send all audit events from enabled resources in {{region}}.": "傳送 {{region}} 中啟用的資源的所有審核事件。",
	"Send all available audit events in this account.": "傳送此帳戶中所有可用審核事件。",
	"Send events to": "將事件傳送至",
	"Send logs to": "將日誌傳送至",
	"Send test notification": "傳送測試通知",
	Sending: Sending,
	"Sent!": "已傳送！",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "無伺服器專案",
	Service: Service,
	"Service access": "服務存取權",
	"Service authorization": "服務授權",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "需要服務授權才能容許活動追蹤器事件遞送與「雲端日誌」進行通訊。 按一下<span>立即授權</span>，以建立適用於該帳戶中所有「雲端日誌」資源的原則。",
	"Service authorization required": "需要服務授權",
	"Service instance": "服務實例",
	"Service name": "服務名稱",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "必須為您的實例提供服務對服務授權。 <a>進一步瞭解</a>",
	"Service to service authorization policy found": "找到服務對服務授權原則",
	"Service to service authorization policy needed": "需要服務對服務授權原則",
	"Service type": "服務類型",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "無法驗證服務對服務授權。 手動新增並檢查必要的角色。",
	"Service-to-service authorization requirements are met.": "符合服務對服務授權需求。",
	"Set an interval (in months)": "設定間隔（以月為單位）",
	"Set key rotation policy": "設定金鑰輪換原則",
	"Set up auth": "設定鑑別",
	Settings: Settings,
	"Short (32px)": "低 (32px)",
	"Show all filters": "顯示所有過濾器",
	"Show code sample": "顯示程式碼範例",
	"Show environments information": "顯示環境資訊",
	"Show error information": "顯示錯誤資訊",
	"Show information": "顯示資訊",
	"Show less": "顯示更少",
	"Show more": "顯示更多",
	"Show more details": "顯示更多詳細資料",
	"Show password": "顯示密碼",
	"Show tooltip": "顯示工具提示",
	"Showing {{count}} item": "顯示 {{count}} 個項目",
	"Showing {{count}} items": "顯示 {{count}} 個項目",
	Size: Size,
	"Small (32px)": "小型 (32px)",
	"Some events from {{serviceName}}:": "一些來自 {{serviceName}} 的事件：",
	"Something went wrong": "發生問題",
	"Something went wrong.": "發生錯誤。",
	"Something went wrong. Try reloading the page to see this information": "發生錯誤。 請嘗試重新載入頁面，以查看此資訊",
	Sort: Sort,
	"Sort ascending": "遞增排序",
	"Sort descending": "遞減排序",
	Source: Source,
	"Source Details": "來源詳細資料",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "服務的來源不存在於事件通知實例中。 請與管理員聯絡。",
	"Source service": "來源服務",
	"Specific namespaces not supported": "不支援特定的名稱空間",
	"Specific projects not supported": "不支援特定的專案",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "一開始先建立一個剛好適合執行工作負載的叢集。",
	"Start date": "開始日期",
	"Starting at": "起始於",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "起始成本基於此資源配置。 將此產品新增至專案後，您可以編輯配置，這可能會影響成本。",
	State: State,
	Status: Status,
	"status icon": "狀態圖示",
	"Stay in pattern": "保持型樣",
	"Steps complete": "步驟完成",
	Storage: Storage,
	"Storage bucket (optional)": "儲存空間儲存區（選用）",
	"Storage configuration missing": "遺漏儲存體配置",
	"Storage ready": "儲存體備妥",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "儲存、搜尋、分析、監視 IBM Cloud 記載資料及事件，並針對其發出警示。",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "成功狀態",
	"Success! This promotion was applied to your account.": "成功！ 此促銷已套用至您的帳戶。",
	"Successfully created new Key Protect instance": "已成功建立新的 Key Protect 實例",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "支援方案",
	"Switch to folders view": "切換至資料夾視圖",
	"Switch to objects view": "切換至物件視圖",
	Sydney: Sydney,
	"Syntax: ": "語法： ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "無法建立標籤 '{{tagName}}'，因為名稱無效。",
	tags: tags,
	Tags: Tags,
	"Tags:": "標籤：",
	"Tags: (optional)": "標籤：（選用）",
	"Tall (64px)": "高 (64px)",
	"Target destination": "目標目的地",
	"Target location": "目標位置",
	"Target name": "目標名稱",
	"Target selected": "已選取目標",
	"Target service instance": "目標服務實例",
	"Target type": "目標類型",
	"Template error": "範本錯誤",
	"Terms and conditions": "條款",
	"Test notification": "測試通知",
	"The address field is required.": "位址欄位是必要項目。",
	"The catalog window might have been blocked from opening.": "型錄視窗可能已封鎖而無法開啟。",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "已從帳戶中刪除已連接的事件通知實例。 若要繼續使用通知，請按一下功能表 ( ⋮ ) 中的「中斷連線」，以中斷現行實例的連線。然後，連接另一個事件通知實例。",
	"The description should not contain any leading or trailing whitespace characters.": "說明不應包含任何前導或尾端空格字元。",
	"The description should not exceed {{limit}} characters in length.": "說明的長度不應超過 {{limit}} 個字元。",
	"The following access is required:": "需要下列存取權：",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "下列程式碼預覽會將對應的要求顯示為 CLI 指令。 使用它作為撰寫您自己自動化的起點。 ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "下列程式碼預覽會將對應的要求顯示為 REST API 呼叫。 使用它作為撰寫您自己自動化的起點。 ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "下列程式碼預覽會顯示具有 Terraform 的對應要求。 使用它作為撰寫您自己自動化的起點。 ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "下列預覽會將對應的要求顯示為程式碼。 使用它作為撰寫您自己自動化的起點。",
	"The following resources were not included in the cost estimate but might have an associated cost.": "下列資源未包括在成本預估中，但可能有相關聯的成本。",
	"The IAM role manager for {{serviceName}}": "{{serviceName}} 的 IAM 角色管理員",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "無法存取實例，因為已從帳戶移除服務對服務授權。 在 {{sourceServiceName}} 和 Event Notifications 之間建立具有「事件來源管理程式」存取權的授權。",
	"The list of namespaces can't be populated. Try again later.": "無法移入名稱空間清單。 請稍後重試。",
	"The list of projects can't be populated. Try again later.": "無法移入專案清單。 請稍後重試。",
	"The name is required.": "需要提供名稱。",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "名稱必須是 {{max}} 或更少字元，以字母開頭，且只包含英數字元、'-' 及 '.'",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "名稱空間的名稱只能包含小寫字母、數字及橫線。 該名稱的開頭或結尾不能是橫線，而且最多不得超過 63 個字元。",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "專案的名稱只能包含小寫字母、數字及橫線。 該名稱的開頭或結尾不能是橫線，而且最多不得超過 63 個字元。",
	"The name should contain only alphanumeric, underscore, dashes and space.": "名稱應該只包含英數、底線、橫線和空格。",
	"The name should not contain any special characters.": "名稱不應包含任何特殊字元。",
	"The name should not exceed {{limit}} characters in length.": "名稱長度不應超過 {{limit}} 個字元。",
	"The region is required.": "需要區域。",
	"The resource group is required.": "需要資源群組。",
	"The resource group window might have been blocked from opening.": "資源群組視窗可能已遭封鎖而無法開啟。",
	"The tag name must be in a key:value format": "標籤名稱必須是 key:value 格式",
	"The tag name must be in a key:value format.": "標籤名稱必須採用 key:value 格式。",
	"The window might have been blocked from opening.": "視窗可能已封鎖，無法開啟。",
	"There was a problem loading resource groups.": "載入資源群組時發生問題。",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "這些角色容許使用服務以及執行服務 API 呼叫的存取權。 每個角色都是透過選取的服務進行自訂。 選取所有適用的項目。 如需詳細資料，請參閱服務的文件。",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "這些角色是由帳戶的管理者所建立，以便自訂如何指派存取權給服務。 請按一下角色的動作圖示，以檢閱哪些動作對映到此角色。",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "這些角色可對平台資源執行動作，例如建立實例、將實例連接至應用程式，以及指派使用者存取權。 選取所有適用的項目。",
	"This field is required": "這是必要欄位",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "目前未在提交時傳送此項目，且正在等待負責 API 的團隊進行更新。",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "這是在 Event Notifications 中引用您的 {{serviceName}} 實例的方式",
	"This project name \"{{name}}\" already exists, please choose another name.": "此專案名稱 \"{{name}}\" 已存在，請選擇其他名稱。",
	"This section is under construction, come back later.": "這個區段正在建構中，請稍後回來。",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "此服務需要指派給叢集的其他儲存體。 不存在相符的儲存體配置。",
	"This tag already exists. Choose another name for your tag.": "此標籤已存在。 請為您的標籤選擇其他名稱。",
	"This value already exists.": "此值已存在。",
	"This view is not available for some account types": "此視圖不適用於部分帳戶類型",
	"Three zone names are required": "需要三個區域名稱",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "若要新增 HPCS 加密，請執行下列步驟：",
	"To connect, the instance in this region must be configured for platform": "若要連接，必須針對平台配置此地區中的實例",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "若要控制由 {{serviceName}} 產生的事件通知，請連線到 Event Notifications 實例。 <a>進一步瞭解</a>",
	"To create a new HPCS key, follow the steps below...": "若要建立新的 HPCS 金鑰，請依照下列步驟操作…",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "帳戶總數",
	"Total estimated cost": "預估成本總計",
	"Transaction ID": "交易 ID",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "請稍後重試，或聯絡您的帳戶管理者。",
	"Try again later.": "請稍後重試。",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "請嘗試重新整理頁面，然後重新執行動作，以查看問題是否持續存在。 若是如此，請確定您是使用<a>受支援的瀏覽器</a>，並檢查<a>狀態頁面</a>，以查看是否有其他項目正在進行。 如果您仍然遇到問題，請與<a>支援中心</a>聯絡以尋求協助。",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "請嘗試等待幾分鐘，然後再度執行動作，看看問題是否持續存在。 如果是，請檢查<a>狀態頁面</a>，查明是否有其他事故。 如果您仍然遇到問題，請與<a>支援中心</a>聯絡以尋求協助。",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "輸入 \"{{clusterName}}\" 以確認",
	"Type \"{{name}}\" to confirm": "鍵入 \"{{name}}\" 以確認",
	"Unable to configure activity tracker event routing.": "無法配置活動追蹤器事件遞送。",
	"Unable to configure Activity Tracker integration.": "無法配置活動追蹤器整合。",
	"Unable to configure Logging integration.": "無法配置記載整合。",
	"Unable to configure logging.": "無法配置記載。",
	"Unable to connect your service to Event Notifications service. Try again later.": "無法將您的服務連接至事件通知服務。 請稍後重試。",
	"Unable to create authorization policy.": "無法建立授權原則。",
	"Unable to create Satellite location": "無法建立 Satellite 位置",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "目前無法建立服務對服務原則。 請重新整理頁面，或稍後重試。",
	"Unable to delete cluster": "無法刪除叢集",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "無法中斷事件通知實例的連線。 請重新整理頁面，或稍後重試。",
	"Unable to get cluster data": "無法取得叢集資料",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "無法取得事件通知實例詳細資料。 請重新整理頁面，或稍後重試。",
	"Unable to get storage instances.": "無法取得儲存空間實例。",
	"Unable to list clusters.": "無法列出叢集。",
	"Unable to list locations.": "無法列出位置。",
	"Unable to load Activity Tracker service catalog data": "無法載入活動追蹤器服務型錄資料",
	"Unable to load Cloud Logs service catalog data": "無法載入「雲端日誌」服務型錄資料",
	"Unable to load cluster details.": "無法載入叢集詳細資料。",
	"Unable to load cluster update version options.": "無法載入叢集更新版本選項。",
	"Unable to load event routing settings": "無法載入事件遞送設定",
	"Unable to load event routing target instances": "無法載入事件遞送目標實例",
	"Unable to load event routing target instances.": "無法載入事件遞送目標實例。",
	"Unable to load event routing targets": "無法載入事件遞送目標",
	"Unable to load event routing targets.": "無法載入事件遞送目標。",
	"Unable to load IBM Cloud locations data": "無法載入 IBM Cloud 位置資料",
	"Unable to load logging instances": "無法載入記載實例",
	"Unable to load logging instances.": "無法載入記載實例。",
	"Unable to load logging service catalog data": "無法載入記載服務型錄資料",
	"Unable to load logs routing targets": "無法載入日誌遞送目標",
	"Unable to load logs routing targets.": "無法載入日誌遞送目標。",
	"Unable to perform": "無法執行",
	"Unable to retrieve cluster details": "無法擷取叢集詳細資料",
	"Unable to retrieve data": "無法擷取資料",
	"Unable to retrieve location information.": "無法擷取位置資訊。",
	"Unable to retrieve project configurations.": "無法擷取專案配置。",
	"Unable to send test notification to Event Notifications instance. Try again later.": "無法將測試通知傳送至事件通知實例。 請稍後重試。",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "無法將測試通知傳送至事件通知實例。 檢查是否已在事件通知中設定主題。",
	"Unable to update cluster version.": "無法更新叢集版本。",
	Unknown: Unknown,
	"unknown state": "不明狀態",
	"Unselect all rows": "取消選取所有列",
	"Unselect row": "取消選取列",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "不受支援的版本。 請更新版本以繼續獲得支援。",
	"Upcoming scheduled events in your timezone": "時區中即將發生的排程事件",
	Update: Update,
	"Update available": "有更新可用",
	"Update cluster version": "更新叢集版本",
	"Update tags": "更新標籤",
	"Update version": "更新版本",
	"Updating...": "正在更新...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "請升級帳戶，以檢視計費期間。",
	"Usage based charges apply per gigabyte of audit events ingested.": "以使用量為基礎的收費依照每 GB 汲取的審核事件收取。",
	"Usage based charges apply per gigabyte of logs ingested.": "以使用量為基礎的收費依照每 GB 汲取的日誌收取。",
	"Usage costs": "使用量費用",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "使用密鑰來安全地集中管理用於鑑別的認證。 <a>進一步瞭解</a>",
	"Use a secret?": "使用密鑰嗎？",
	"Use existing": "使用現有",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "使用金鑰別名來輕鬆識別您的金鑰。 金鑰別名是唯一且容易識別的自訂名稱。",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "使用標籤來組織您的資源。 如果您的使用者標籤與計費相關，請考慮將標籤寫成 key:value 配對以協助分組相關的標籤，例如",
	"Use the options below to choose the item that the reference will be created for.": "使用下列選項來選擇將為其建立參照的項目。",
	"User evaluation required": "需要使用者評估",
	"User permissions failure": "使用者權限失敗",
	"User tags": "使用者標籤",
	"User tags (optional": "使用者標籤（選用）",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "使用者標籤在整個帳戶中都是可看見的。 請避免在標籤名稱中包括機密資料。",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "值必須是有效的陣列（例如 [\"array\"]）。 如果要指定空值陣列，請使用 \"__NOT_SET__\"",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "請驗證下列服務已安裝在位置上：{{missingServices}}。",
	Version: Version,
	View: View,
	"View all": "檢視全部",
	"View audit events": "檢視審核事件",
	"View docs": "檢視文件",
	"View error information": "檢視錯誤資訊",
	"View logging": "檢視記載",
	"View-only mode": "僅限檢視模式",
	"VPC Gen1": "VPC 第 1 代",
	"VPC Gen2": "VPC 第 2 代",
	Warning: Warning,
	"warning state": "警告狀態",
	"Washington DC": "華盛頓哥倫比亞特區",
	Wednesday: Wednesday,
	"What you will need:": "您將需要的內容：",
	"What's the purpose of this project?": "這個專案的用途是什麼？",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "刪除叢集時，會永久地刪除所有的工作者節點、應用程式及容器。 這個動作無法復原。 在您繼續之前，請確定先備份所有必要的資料及配置檔。",
	"Worker count": "工作者計數",
	Workloads: Workloads,
	"Wrong Syntax": "語法錯誤",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "您已具有一個使用此名稱的位置。 輸入唯一名稱。",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "您已有 Security and Compliance Center 的實例。 若要查看結果，您必須建立附件來排定第一次掃描。",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "您對原則資源的存取權層次，導致您無法修改此原則。 如果您想要修改的能力，請與管理者聯絡，以更新您的資源存取權。",
	"You can find a list of resources here once you create them.": "建立資源清單之後，您可以在這裡找到資源清單。",
	"You can find your resource details here after you create them.": "建立資源詳細資料之後，您可以在這裡找到資源詳細資料。",
	"You can find your resources here after you create them.": "在建立資源之後，您可以在這裡找到資源。",
	"You can find your Satellite locations here after you create them.": "在建立衛星位置之後，您可以在這裡找到它們。",
	"You do not have access to any resource groups.": "您無權存取任何資源群組。",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "您無權存取任何資源群組。 <a>建立</a>資源群組。",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "您沒有編輯標籤的權限。 如果您需要更多的存取權，請聯絡您的管理者。",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "您沒有在 \"{{project}}\" 中新增配置的正確存取權",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "您具有受限存取權，且可能無法新增或移除標籤。 如果您需要更多的存取權，請聯絡您的管理者。",
	"You haven't connected an Event Notifications service instance yet.": "您尚未連接 Event Notifications 服務實例。",
	"You may also <a>create an instance</a>.": "您也可以<a>建立實例</a>。",
	"You may also create a new one.": "您也可以建立一個新的。",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "您可能已啟用環境定義型限制或 IAM 原則。 請聯絡您的帳戶管理者。",
	"You must have at least one active root key. Try creating a new one.": "您必須至少有一個作用中的根金鑰。 嘗試建立一個新的。",
	"You need at least 1 topic to send a test notification.": "您至少需要 1 個主題來傳送測試通知。",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "針對此專案，您需要 IBM Cloud 專案服務的「編輯者」或「管理者」角色。 <a>指派您自己的存取權</a>，或向您的帳戶管理者要求存取權。",
	"You're adding tags to:": "您正在新增標籤至：",
	"You're editing tags for:": "您正在編輯的標籤是關於：",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "您未獲授權來連接此實例。 請驗證您的許可權，或聯絡您的管理者。",
	"You're using the newest version of the API server. There are no updates available at this time.": "您正在使用最新版的 API 伺服器。 目前沒有可用的更新。",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "您已經到達一次可以附加的標籤數上限。 若要附加更多標籤，請先儲存變更。",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "您的 API 伺服器正在更新到第 {{version}} 版。 完成之後，您可以將工作者節點更新至相同版本。",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "放大影像",
	"Zoom out image": "縮小影像"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, zhTw as default, hour, hr, mo, more, provided, region, resources, tag, tags };
